/**
 * Pure search/filter logic for Plaatsen (spec §8.5: search across object,
 * category, subzone and notes — exact location included as well).
 */
import type { Place } from '@/types'
import { ALL_CATEGORY } from './categories'

function searchableFields(place: Place): string[] {
  return [place.objectLabel, place.category, place.subzone, place.exactLocation, place.notes]
    .filter((field): field is string => typeof field === 'string' && field.length > 0)
}

export function placeMatchesQuery(place: Place, normalizedQuery: string): boolean {
  if (!normalizedQuery) return true
  return searchableFields(place).some((field) => field.toLowerCase().includes(normalizedQuery))
}

export function searchPlaces(
  places: readonly Place[],
  query: string,
  categoryFilter: string,
): Place[] {
  const normalizedQuery = query.trim().toLowerCase()
  return places.filter((place) => {
    if (categoryFilter !== ALL_CATEGORY && place.category !== categoryFilter) return false
    return placeMatchesQuery(place, normalizedQuery)
  })
}
